/**
 * Collection Page Enhancements
 * Smooth scroll behavior for filters
 */

document.addEventListener('DOMContentLoaded', function() {
  // Smooth scroll behavior for filter changes
  const filterButtons = document.querySelectorAll('.collection__filter-trigger, .facets__summary');
  filterButtons.forEach(button => {
    button.addEventListener('click', function() {
      setTimeout(() => {
        const productGrid = document.querySelector('.collection__grid');
        if (productGrid) {
          productGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    });
  });

  // Mobile tap behavior: show hover image, then navigate after 2 seconds
  if (window.innerWidth <= 768 || 'ontouchstart' in window) {
    // Use event delegation on document to catch all product card clicks
    document.addEventListener('click', function(e) {
      // Find if click was on or inside a product card link
      const productLink = e.target.closest('.card-wrapper a, .product-card a, .card a, a.card-link, .product-item a');
      if (!productLink) return;

      // Find the card element
      const card = productLink.querySelector('.card') || productLink.closest('.card') || productLink;
      if (!card) return;

      // Check if there's a hover image
      const hoverImg = card.querySelector('.card__img--hover, .card__media img:nth-child(2), .secondary-image');
      if (!hoverImg) return;

      // Check if already tapped
      if (card.dataset.mobileTapped === 'true') return;

      // Prevent navigation
      e.preventDefault();
      e.stopPropagation();

      // Show hover image
      card.classList.add('mobile-tapped');
      card.dataset.mobileTapped = 'true';

      // Store the destination URL
      const destinationUrl = productLink.href;

      // Navigate after 2 seconds
      setTimeout(() => {
        if (destinationUrl) {
          window.location.href = destinationUrl;
        }
      }, 2000);
    }, true); // Use capture phase to intercept before default handling
  }
});
